import React, { Component } from 'react';
import { Form, FormGroup, Label, Button, ModalHeader, ModalBody, ModalFooter, Col, Row, } from 'reactstrap';
import { Field, reduxForm,FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import { validateProductFormData, sectionDataTransform, crawlerSelectionTransform, prepareCrawlerRequestData } from './helper';
import Modal from '../../../../../components/UI/Modal/Modal';
import MultiSelect from '../../../../../components/ReusableComponents/MultiSelect/index';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import CorporateModal from '../../../../../components/UI/CorporateModal/index';
import {standardProductType,BUSINESS_CHECK_CREDIT,ROC_SEARCH_REPORT,DUE_DILIGENCE_REPORT,EWS,PORTFOLIO_SCRUB,COMPLIANCE,BUSINESS_CHECK_COMPETITOR,BUSINESS_PROFILE_REPORT,SITE_VISIT,SHIPPING_DATA,MCA_DOCUMENT_DOWNLOAD,BUSINESS_CHECK_SUPPLIER,BUSINESS_CHECK_INTERNATIONAL,TEV,ENHANCED_DUE_DILIGENCE,KYC,LEI_VALIDATION,LEI_VERIFICATION,PROJECT_FIXED_COST,DEBT_COLLECTIONS,SKIP_TRACE,LEGAL_SERVICES,MDM,DATA_PROJECTS, spcsOptions,CDM_CUSTOMER,CDM_SUPPLIER,CDM_INTERNATIONAL ,FI_PROJECTS, B2B_PROJECTS,FI_KYC_SOLUTIONS,FI_LEI,B2B_AR_MANAGEMENT,B2B_DEBT_COLLECTIONS,PROJECTS_MDM,PROJECTS_OTHERS, AR_MANAGEMENT_FIXED, AR_MANAGEMENT_VARIABLE, CDM_PROJECTS_TEV, CDM_PROJECTS_EDD, MSME, CDM_PROJECTS_MSME,PROJECT_VARIABLE_COST,LEI_COMMISSION,COMMISSION,COMMISSION_SP,RESOURCE_COST,ESG} from '../../../Constant';
const crawlerData = [{ id: "DATABASE", name: "DATABASE" }, { id: "GST", name: "GST" }, { id: "EPF", name: "EPF" }, { id: "MCA", name: "MCA" }, { id: "LEGAL", name: "LEGAL" }, { id: "RATINGS", name: "RATINGS" }, { id: "SOCIALMEDIA", name: "SOCIALMEDIA" }]
const typeOfBuyerSellerRelationship = [{ id: "PRIMARY"}, { id: "SECONDARY"}, { id: "TERTIARY"}]
class ProductDetailsForm extends Component {
    constructor() {
        super();
        this.state = {
            dropdownOpen: false,
            showModal: false,
            showCorporateModal: false,
            AddsectionData: [],
            selectedCreditLimitModel:[],
            selectedCreditValue:[],
            body: null,
            sectionData: [],
            sectionList: [],
            crawlersData: [],
            selectedCreditLimit:false,
            initialFormData:"",
            selectdModels :[],
            reportCategoryList :[],
            reportFrontCoverList :[],
            standardProduct :null,
            standardProductCategory :null,
            standardProductSegment : null,
            standardProductCategoryOptions:['CDM - Customer','CDM - Supplier','CDM - International','CDM - Projects - TEV','CDM - Projects - EDD','CDM - MSME','FI - KYC Solutions','FI - LEI','FI - Projects','B2B - AR Management','B2B - Debt Collections','B2B - Projects','Projects - MDM','Projects - Others','Resource Cost'],
            standardProductSegmentOptions:["Credit Decisioning and Monitoring (CDM)","Fraud and ID Solutions (FI)","B2B Collections","Projects","Referral"]
        }
    }
    handleStandardProduct = (value) => {    
        if(value == BUSINESS_CHECK_CREDIT){
            this.setState({
                standardProductCategoryOptions:spcsOptions[BUSINESS_CHECK_CREDIT],
                standardProductSegmentOptions:spcsOptions[CDM_CUSTOMER]})
        }else if(value == ROC_SEARCH_REPORT){
            this.setState({
                standardProductCategoryOptions:spcsOptions[ROC_SEARCH_REPORT],
                standardProductSegmentOptions:spcsOptions[CDM_CUSTOMER]})
        }else if(value == DUE_DILIGENCE_REPORT){
            this.setState({
                standardProductCategoryOptions:spcsOptions[DUE_DILIGENCE_REPORT],
                standardProductSegmentOptions:spcsOptions[CDM_CUSTOMER]})
        }else if(value == EWS){
            this.setState({
                standardProductCategoryOptions:spcsOptions[EWS],
                standardProductSegmentOptions:spcsOptions[CDM_CUSTOMER]})
        }else if(value == COMPLIANCE){
            this.setState({
                standardProductCategoryOptions:spcsOptions[COMPLIANCE],
                standardProductSegmentOptions:spcsOptions[CDM_CUSTOMER]})
        }else if(value == PORTFOLIO_SCRUB){
            this.setState({
                standardProductCategoryOptions:spcsOptions[PORTFOLIO_SCRUB],
                standardProductSegmentOptions:spcsOptions[CDM_CUSTOMER]})
        }else if(value == BUSINESS_CHECK_COMPETITOR){
            this.setState({
                standardProductCategoryOptions:spcsOptions[BUSINESS_CHECK_COMPETITOR],
                standardProductSegmentOptions:spcsOptions[CDM_CUSTOMER]})
        }else if(value == BUSINESS_PROFILE_REPORT){
            this.setState({
                standardProductCategoryOptions:spcsOptions[BUSINESS_PROFILE_REPORT],
                standardProductSegmentOptions:spcsOptions[CDM_CUSTOMER]})
        }else if(value == SITE_VISIT){
            this.setState({
                standardProductCategoryOptions:spcsOptions[SITE_VISIT],
                standardProductSegmentOptions:spcsOptions[CDM_CUSTOMER]})
        }else if(value == SHIPPING_DATA){
            this.setState({
                standardProductCategoryOptions:spcsOptions[SHIPPING_DATA],
                standardProductSegmentOptions:spcsOptions[CDM_CUSTOMER]})
        }else if(value == MCA_DOCUMENT_DOWNLOAD){
            this.setState({
                standardProductCategoryOptions:spcsOptions[MCA_DOCUMENT_DOWNLOAD],
                standardProductSegmentOptions:spcsOptions[CDM_CUSTOMER]})
        }else if(value == BUSINESS_CHECK_SUPPLIER){
            this.setState({
                standardProductCategoryOptions:spcsOptions[BUSINESS_CHECK_SUPPLIER],
                standardProductSegmentOptions:spcsOptions[CDM_SUPPLIER]})
        }else if(value == BUSINESS_CHECK_INTERNATIONAL){
            this.setState({
                standardProductCategoryOptions:spcsOptions[BUSINESS_CHECK_INTERNATIONAL],
                standardProductSegmentOptions:spcsOptions[CDM_INTERNATIONAL]})
        }else if(value == TEV){
            this.setState({
                standardProductCategoryOptions:spcsOptions[TEV],
                standardProductSegmentOptions:spcsOptions[CDM_PROJECTS_TEV]})
        }else if(value == ENHANCED_DUE_DILIGENCE){
            this.setState({
                standardProductCategoryOptions:spcsOptions[ENHANCED_DUE_DILIGENCE],
                standardProductSegmentOptions:spcsOptions[CDM_PROJECTS_EDD]})
        }else if(value == MSME){
            this.setState({
                standardProductCategoryOptions:spcsOptions[MSME],
                standardProductSegmentOptions:spcsOptions[CDM_PROJECTS_MSME]})
        }else if(value == KYC){
            this.setState({
                standardProductCategoryOptions:spcsOptions[KYC],
                standardProductSegmentOptions:spcsOptions[FI_KYC_SOLUTIONS]})
        }else if(value == LEI_VALIDATION){
            this.setState({
                standardProductCategoryOptions:spcsOptions[LEI_VALIDATION],
                standardProductSegmentOptions:spcsOptions[FI_LEI]})
        }else if(value == LEI_VERIFICATION){
            this.setState({
                standardProductCategoryOptions:spcsOptions[LEI_VERIFICATION],
                standardProductSegmentOptions:spcsOptions[FI_LEI]})
        }else if(value == PROJECT_FIXED_COST){
            this.setState({
                standardProductCategoryOptions:spcsOptions[PROJECT_FIXED_COST],
                standardProductSegmentOptions:spcsOptions[FI_PROJECTS]})
        }else if(value == AR_MANAGEMENT_FIXED){
            this.setState({
                standardProductCategoryOptions:spcsOptions[AR_MANAGEMENT_FIXED],
                standardProductSegmentOptions:spcsOptions[B2B_AR_MANAGEMENT]})
        }else if(value == AR_MANAGEMENT_VARIABLE){
            this.setState({
                standardProductCategoryOptions:spcsOptions[AR_MANAGEMENT_VARIABLE],
                standardProductSegmentOptions:spcsOptions[B2B_AR_MANAGEMENT]})
        }else if(value == DEBT_COLLECTIONS){
            this.setState({
                standardProductCategoryOptions:spcsOptions[DEBT_COLLECTIONS],
                standardProductSegmentOptions:spcsOptions[B2B_DEBT_COLLECTIONS]})
        }else if(value == SKIP_TRACE){
            this.setState({
                standardProductCategoryOptions:spcsOptions[SKIP_TRACE],
                standardProductSegmentOptions:spcsOptions[B2B_PROJECTS]})
        }else if(value == LEGAL_SERVICES){
            this.setState({
                standardProductCategoryOptions:spcsOptions[LEGAL_SERVICES],
                standardProductSegmentOptions:spcsOptions[B2B_PROJECTS]})
        }else if(value == MDM){
            this.setState({
                standardProductCategoryOptions:spcsOptions[MDM],
                standardProductSegmentOptions:spcsOptions[PROJECTS_MDM]})
        }
        else if(value == DATA_PROJECTS){
            this.setState({
                standardProductCategoryOptions:spcsOptions[DATA_PROJECTS],
                standardProductSegmentOptions:spcsOptions[PROJECTS_OTHERS]})
        }
        else if(value == RESOURCE_COST){
            this.setState({
                standardProductCategoryOptions:spcsOptions[RESOURCE_COST],
                standardProductSegmentOptions:spcsOptions[PROJECTS_OTHERS]})
        }
        else if(value == PROJECT_VARIABLE_COST){
            this.setState({
                standardProductCategoryOptions:spcsOptions[PROJECT_VARIABLE_COST],
                standardProductSegmentOptions:spcsOptions[FI_PROJECTS]})
        }
        else if(value == LEI_COMMISSION){
            this.setState({
                standardProductCategoryOptions:spcsOptions[LEI_COMMISSION],
                standardProductSegmentOptions:spcsOptions[FI_LEI]})
        }
        else if(value == COMMISSION){
                    this.setState({
                        standardProductCategoryOptions:COMMISSION_SP,
                        standardProductSegmentOptions:spcsOptions[COMMISSION]})
        }
        else if(value == ESG){
                    this.setState({
                        standardProductCategoryOptions:ESG,
                        standardProductSegmentOptions:spcsOptions[ESG]})
        }
        
    }

    componentDidMount() {
        this.setState({
            initialFormData:this.props.productFormData
        });
        this.props.initialize({
            "creditLimitModels": [],
            })
    }

    componentDidUpdate(prevProps) {
        if(this.props.initialValues !== prevProps.initialValues){
            if(this.props.initialValues.standardProduct != null){
                this.handleStandardProduct(this.props.initialValues.standardProduct);
            } 
         }
        if (this.props.updateFlag !== prevProps.updateFlag) {
            this.setState({
                sectionData: this.props.selectedSectionList,
                crawlersData: this.props.crawlersData
            })
            this.props.reset();
            this.preCheckCreditLimitModel(this.props.selectedSectionList)
        } 
        if (this.props.reportCategoryDropdownList !== prevProps.reportCategoryDropdownList) {
            this.setState({
                reportCategoryList: this.props.reportCategoryDropdownList,
            })
            
        } 
        if (this.props.reportFrontCoverDropdownList !== prevProps.reportFrontCoverDropdownList) {
            this.setState({
                reportFrontCoverList: this.props.reportFrontCoverDropdownList,
            })
        }
    }

    preCheckCreditLimitModel = (selectedSectionList) => {
        const tempArr = Array.from(selectedSectionList)
        for (let i = 0; i < tempArr.length; i++) {
            if (tempArr[i].tags !==null && tempArr[i].tags[0] !== null) {
                if (tempArr[i].tags[0] === "CreditLimit") {
                    this.setState({
                        selectedCreditLimit: true
                    })
                }
            }
        }
    }

    checkCreditLimitSection =(sectionData)=>{
        if(sectionData[0].tags !== null && sectionData[0].tags[0]==='CreditLimit'){
            this.setState({
            selectedCreditLimit:true
            })
        } 
    } 
    
    toggleModal = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            body: null
        }));
    }
    handleSectionList = (selectedSectionData) => {
        this.setState({
            sectionData: selectedSectionData
        })
    }
    selectedEntityCallback = (selectedSectionData) => {
        const tempSectionData = sectionDataTransform(selectedSectionData);
        this.setState({
            sectionData: tempSectionData
        })
    }
    selectedEntityCallbackForSectionsAddition = (selectedSectionData) => {
        this.checkCreditLimitSection(selectedSectionData);
        const tempSectionData = sectionDataTransform(selectedSectionData);
        this.setState({
            AddsectionData: tempSectionData
        })
    }

    handleMultiSelectForCrawler = (selectedOption) => {
        const tempData = crawlerSelectionTransform(selectedOption);
        this.setState({ crawlersData: tempData })
    }

    reorder = (sections, startIndex, endIndex) => {
        const result = Array.from(sections);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            const tempArr = Array.from(this.state.sectionData);
            tempArr.splice(result.source.index, 1);
            if(this.state.selectedCreditLimit){
                let checkCreditLimitModel = false
                for(let i=0;i<tempArr.length;i++){
                   if(tempArr[i].tags !==null && tempArr[i].tags[0] !== null) {
                   if(tempArr[i].tags[0] === "CreditLimit"){
                    checkCreditLimitModel= true
                   }}
                }
                if(!checkCreditLimitModel){
                    this.setState({
                             selectedCreditLimit:false
                        })
                }
            }
            this.setState(prevState => ({
                sectionData: tempArr,
                productData: { ...prevState.productData, "sectionList": tempArr }
            }));
            return;
        }
        const items = this.reorder(
            this.state.sectionData,
            result.source.index,
            result.destination.index
        );
        
        this.setState(prevState => ({
            sectionData: items,
            productData: { ...prevState.productData, "sectionList": items }
        }));
    }
    getListStyle = isDraggingOver => ({
        background: isDraggingOver ? "lightblue" : "#DEE9E3",
        padding: 5,
        width: 480,
        height: 300,
        overflowY: 'scroll'
    });


    getItemStyle = (isDragging, draggableStyle) => ({
        // some basic styles to make the items look a bit nicer
        userSelect: "none",
        padding: 10,
        margin: 5,
        width: 440,
        border: "groove",
        // change background colour if dragging
        background: isDragging ? "lightgray" : "white",

        // styles we need to apply on draggables
        ...draggableStyle
    });

    handleToggle = () => {
        this.setState(prevState => ({
            showCorporateModal: !prevState.showCorporateModal,
            AddsectionData: []
        }))
    }
    handleAdd = () => {
        this.handleToggle();
    }

    allSectionIdList = (sectionData) => {
        let idList = sectionData.map((item) => {
            return item.id
        })
        return idList
    }
    handleAddSections = () => {
        if (this.state.AddsectionData.length == 0) {
            return;
        }
        let sectionIdList = this.allSectionIdList(this.state.sectionData);
        for (let i = 0; i < this.state.AddsectionData.length; i++) {
            if (!sectionIdList.includes(this.state.AddsectionData[i].id)) {
                this.state.sectionData.push(this.state.AddsectionData[i]);
            }
        }
        this.handleToggle();
    }
    handleCancel = () => {
        this.handleToggle();
    }

    calculateWeightage=(modelDetails)=>{
    let addWeightage=0
        for(let i=0;i<modelDetails.length;i++){
            addWeightage+=parseInt(modelDetails[i][`weightage ${i}`])
        }
    return addWeightage;
    }

    calculateWeightages=(modelDetails)=>{
        let addWeightage=0
            for(let i=0;i<modelDetails.length;i++){
                addWeightage+=parseInt(modelDetails[i].weightage)
            }
        return addWeightage;
        }
    
    handleAddProduct = (event) => {
        let formValues = { ...this.props.productFormData.values, crawlers: prepareCrawlerRequestData(this.state.crawlersData) };
        event.preventDefault();
        if(formValues.creditLimitModels && formValues.creditLimitModels.length > 0 && this.calculateWeightages(formValues.creditLimitModels) !== 100){
            this.setState(prevState => ({
                showModal: !prevState.showModal,    
                body: <div>
                    <ModalHeader>Warning</ModalHeader>
                    <ModalBody>
                        <p className="alert alert-warning"><i className="fa fa-exclamation-circle orange"></i>&nbsp;&nbsp; Weightage should be equal to 100</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="info" onClick={this.toggleModal}>Ok</Button>
                    </ModalFooter>
                </div>
            }))
        }
        else{
            if (this.props.productFormData.values && this.props.productFormData.values.productType) {
                formValues = { ...formValues, productType: "QUICK" };
            } else {
                delete formValues["productType"];
            }
            if (this.props.productFormData.values && this.props.productFormData.values.shareable) {
                formValues = { ...formValues, shareable: true };
            } else {
                formValues = { ...formValues, shareable: false };
            }
            if (this.props.productFormData.values && this.props.productFormData.values.clientVisible) {
                formValues = { ...formValues, clientVisible: true };
            } else {
                formValues = { ...formValues, clientVisible: false };
            }
            if (this.props.productFormData.values && this.props.productFormData.values.databaseProduct) {
                formValues = { ...formValues, databaseProduct: true };
            } else {
                formValues = { ...formValues, databaseProduct: false };
            }
            const validateProductData = validateProductFormData(formValues, this.state.sectionData)
            if (validateProductData) {
                this.props.reset();
                this.props.productFormDataCallback(formValues, this.state.sectionData);
            } else {
                this.setState(prevState => ({
                    showModal: !prevState.showModal,
                    body: <div>
                        <ModalHeader>Warning</ModalHeader>
                        <ModalBody>
                            <p className="alert alert-warning"><i className="fa fa-exclamation-circle orange"></i>&nbsp;&nbsp; All Fields Are Required</p>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="info" onClick={this.toggleModal}>Ok</Button>
                        </ModalFooter>
                    </div>
                }))
            }
        }

    }
    
    handleChange=(id,e)=>{
       const {name,value} = e.target;
       let creditFields = this.state.selectedCreditLimitModel;
       creditFields.map((field) =>
       field.id === id ? field[name]=value : field);
       this.setState({
        selectedCreditLimitModel:creditFields
       })
    }

    selectedEntityCallbackForCreditLimitModel=(selectedOption)=>{
        if(selectedOption.length>0){
            let  credilimitObj={}                
            credilimitObj["creditLimitModelId"]=selectedOption[selectedOption.length-1].value
            credilimitObj["label"]=selectedOption[selectedOption.length-1].label
            credilimitObj["creditDays"] = 30;
            this.props.array.push("creditLimitModels", credilimitObj);
        }
		
    }     

    render(){
        let  selecteCreditLimit = ((this.state.selectedCreditLimitModel) ? this.state.selectedCreditLimitModel : []).map((userItem,index) => {
            return ( 
                <li key={index}>
                    <Row>
                        <Col >
                            <Row>
                                <Row>
                                    <Col><span>{userItem.label}</span></Col>
                                    <Col ><Field name={`weightage ${userItem.label}`}
                                    type="number"
                                    className="form-control mb-2 mr-sm-2 mb-sm-0"
                                    component="input"  
                                    onChange={(e) => this.handleChange(userItem.label,e)}
                                    required/></Col>
                                    <Col>
                                    <Field name={`typeOfBuyerSellerRelationship ${userItem.label}`}
                                    type="select"
                                    component='select'
                                    className=" mb-2 mr-sm-2 mb-sm-0"
                                    onChange={(e) => this.handleChange(userItem.label,e)} required
                                    >
                                    <option value=''>Select</option>
                                    {
                                    typeOfBuyerSellerRelationship.map(p => {
                                    return (
                                    <option key={p.id}>{p.id}</option>
                                    )
                                    })
                                    }
                                    </Field>
                                    </Col>
                                    <Col><Field name={`creditDays ${userItem.label}`}
                                    type="number"
                                    className="form-control mb-2 mr-sm-2 mb-sm-0"
                                    component="input"  
                                    onChange={(e) => this.handleChange(userItem.id,e)} required
                                   />
                                   </Col>
                                </Row>    
                            </Row>
                        </Col>
                    </Row>
                    <br/>
                </li>
            )
        })
        return (
            <Form>
                <FormGroup className="w-75">
                    {/* <Label>Select Counterparty Type</Label> */}
                    <label>Counterparty Type&nbsp;<span className="text-danger">*</span></label>
                    <Field name="counterpartyType" component="select" className="form-control dropdown-counterparty border">
                        <option value=''>Select</option>
                        {
                            this.props.counterpartyDropdown.map(p => {
                                return (
                                    <option key={p} value={p}>{p}</option>
                                )
                            })
                        }
                    </Field>
                </FormGroup>
                <FormGroup className="w-75">
                    <label>Report Category&nbsp;<span className="text-danger">*</span></label>
                    <Field name="reportCategory" component="select" className="form-control dropdown-productType border">
                    <option value=''>Select</option>
                        {
                            this.state.reportCategoryList.map(p => {
                                return (
                                    <option key={p} value={p}>{p}</option>
                                )
                            })
                        }
                        
                    </Field>
                </FormGroup>
                <FormGroup className="w-75">
                    <label>Report Front Cover&nbsp;<span className="text-danger">*</span></label>
                    <Field name="reportFrontCover" component="select" className="form-control dropdown-productType border">
                    <option value=''>Select</option>
                        {
                            this.state.reportFrontCoverList.map(p => {
                                return (
                                    <option key={p} value={p}>{p}</option>
                                )
                            })
                        }
                        
                    </Field>
                </FormGroup>
                <FormGroup className="w-75">
                    <Label>Product Name&nbsp;<span className="text-danger">*</span></Label>
                    <Field name="name"
                        type="text"
                        className="form-control"
                        component="input"
                        validate={[required]}
                        placeholder="Enter A Product Name" />
                </FormGroup>
                <FormGroup className="w-75">
                    <Label>Product Title</Label>
                    <Field name="productTitle"
                        type="text"
                        className="form-control"
                        component="input"
                        validate={[required]}
                        placeholder="Enter A Product Title for Cover Page" />
                </FormGroup>
                <FormGroup className="w-75">
                    <Label>Product Description</Label>
                    <Field name="description"
                        type="text"
                        className="form-control"
                        component="input"
                        validate={[required]}
                        placeholder="Enter A Product Description" />
                </FormGroup>

                <FormGroup>
                    <Label className="header-blue d-block p-2 text-primary font-weight-bold">Choose Report Sections <Button className="mx-2" size="sm" outline color="primary" title="Add" id="add" onClick={this.handleAdd}>
                        <i className="icon-plus"></i>Add
                    </Button>
                    </Label>
                    <DragDropContext onDragEnd={this.onDragEnd}>
                        <Droppable droppableId="droppable">
                            {(provided, snapshot) => (
                                <div {...provided.DroppableProps} ref={provided.innerRef}
                                    style={this.getListStyle(snapshot.isDraggingOver)} >
                                    {
                                        this.state.sectionData.map((item, index) => (
                                            <Draggable key={item.id} draggableId={item.id} index={index}>
                                                {(provided, snapshot) => (
                                                    <div className="card" ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={this.getItemStyle(
                                                            snapshot.isDragging,
                                                            provided.draggableProps.style
                                                        )}
                                                    >
                                                        {item.name}

                                                    </div>
                                                )}
                                            </Draggable>
                                        ))
                                    }
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                </FormGroup>


                <FormGroup className="w-75">
                    <Label>Turn around time (days)</Label>
                    <Field name="turnAroundTime" type="text"
                        className="form-control"
                        component="input"
                        validate={[required]}
                        placeholder="Enter number of working days" />
                    {/* <Input type="text" placeholder="Enter number of working days" /> */}
                </FormGroup>
                <FormGroup className="w-75">
                    <Label>Price</Label>

                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text p-2">₹</span>
                        </div>
                        <Field name="price" type="number"
                            className="form-control px-2"
                            component="input"
                            validate={[required]}
                            placeholder="Enter Price" />
                    </div>
                </FormGroup>
                <FormGroup>
                    <div>
                        <label>&nbsp;&nbsp;
                            <Field name="productType" component="input" type="checkbox" />
                            &nbsp;&nbsp; QUICk?
                        </label>
                    </div>
                </FormGroup>

                <FormGroup>
                    <div>
                        <label>&nbsp;&nbsp;
                            <Field name="databaseProduct" component="input" type="checkbox" />
                            &nbsp;&nbsp; Database Product?
                        </label>
                    </div>
                </FormGroup>

                <FormGroup>
                    <div>
                        <label>&nbsp;&nbsp;
                            <Field name="shareable" component="input" type="checkbox" />
                            &nbsp;&nbsp; Shareable?
                        </label>
                    </div>
                </FormGroup>
                <FormGroup>
                    <div>
                        <label>&nbsp;&nbsp;
                            <Field name="clientVisible" component="input" type="checkbox" />
                            &nbsp;&nbsp; isClientVisible ?
                        </label>
                    </div>
                </FormGroup>
                <FormGroup>
                    <div>
                        Report Type:&nbsp;&nbsp;
                        <label>
                            <Field name="reportType" component="input" type="radio" value={"Landscape"} onChange={this.handleCaseTypeChange} />{' '}
                            Landscape
                        </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <label>
                            <Field name="reportType" component="input" type="radio" value={"Portrait"} onChange={this.handleCaseTypeChange} />{' '}
                            Portrait
                        </label>
                    </div>
                </FormGroup>
                <FormGroup>
                    <div>
                        Product Category&nbsp;<span className="text-danger">*</span>:&nbsp;&nbsp;
                        <label>
                            <Field name="productCategory" component="input" type="radio" value={"CORPORATE"} />{' '}
                            Corporate
                        </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <label>
                            <Field name="productCategory" component="input" type="radio" value={"NON_CORPORATE"} />{' '}
                            Non Corporate
                        </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <label>
                            <Field name="productCategory" component="input" type="radio" value={"INTERNATIONAL"} />{' '}
                            International
                        </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <label>
                            <Field name="productCategory" component="input" type="radio" value={"NOT_APPLICABLE"} />{' '}
                            Not Applicable
                        </label>
                    </div>
                </FormGroup>
                <FormGroup className="w-75">
                    <label>Standard Product&nbsp;<span className="text-danger">*</span></label>
                    <Field name="standardProduct"  component="select" className="form-control dropdown-counterparty border" onChange={(e) => this.handleStandardProduct(e.target.value)}>
                    <option value="">Select</option>
                    {
                        standardProductType.map(p => {
                                return (
                                    <option key={p} value={p}>{p}</option>
                                )
                            })
                        }
                    </Field>
                </FormGroup>
                <FormGroup className="w-75">
                    <label>Product Category&nbsp;<span className="text-danger">*</span></label>
                    <Field  name="standardProductCategory" component="select" className="form-control dropdown-counterparty border" onChange={(e) => this.handleStandardProduct(e.target.value)} >
                        <option value="">Select</option>
                        {
                            this.state.standardProductCategoryOptions.map(p => {
                                    return (
                                        <option key={p} value={p}>{p}</option>
                                    )
                                })
                            }
                        </Field>
                </FormGroup>
                <FormGroup className="w-75">
                    <label>Product Segment&nbsp;<span className="text-danger">*</span></label>
                    <Field  name="standardProductSegment" component="select" className="form-control dropdown-counterparty border" >
                        <option value="">Select</option>
                        {
                            this.state.standardProductSegmentOptions.map(p => {
                                return (
                                    <option key={p} value={p}>{p}</option>
                                )
                            })
                        }
                    </Field>
                </FormGroup>
                <FormGroup>
                    <Label>Choose Crawlers for API</Label>
                    <MultiSelect data={crawlerData} selected={this.handleMultiSelectForCrawler} selectedValue={this.state.crawlersData} />
                </FormGroup>
                {(this.state.selectedCreditLimit)?
                <FormGroup>
                    <Label>Choose Credit Limit Model</Label>
                    <MultiSelect data={this.props.creditLimitModelList} selected={this.selectedEntityCallbackForCreditLimitModel} selectedValue={this.state.selectedCreditValue}/>
                </FormGroup>            
                :''}
                {(this.state.selectedCreditLimit)?
                <Row>
                <Col><Label>Name</Label></Col>
                <Col><Label>Weightage</Label></Col>
                <Col><Label>Type Of Buyer Seller Relationship</Label></Col>
                <Col><Label>Credit Days</Label></Col> 
                <Col><Label></Label></Col>
                </Row> 
                :''}
                {(this.state.selectedCreditLimit)?
                <FieldArray name="creditLimitModels" component={renderMembers} data={this.state.selectedCreditLimitModel}dropDownOptions={typeOfBuyerSellerRelationship}/>
                :''}
                {selecteCreditLimit} 
                <FormGroup className="w-75">
                    <Button type="submit" color="primary" onClick={this.handleAddProduct}>Add</Button>
                </FormGroup>
                <Modal show={this.state.showModal} modalClosed={this.close} >
                    {/* {/ <p>Show Modal Data</p > /} */}
                    {this.state.body}
                </Modal>
                <CorporateModal toShow={this.state.showCorporateModal} modalClosed={this.handleToggle}
                    body={<Form >
                        <Row>
                            <Col >
                                <FormGroup>
                                    <Label>Choose Report Sections</Label>
                                    <MultiSelect data={this.props.productSectionList} selected={this.selectedEntityCallbackForSectionsAddition} selectedValue={this.state.AddsectionData} />
                                </FormGroup>
                                <FormGroup>
                                    <Button className="btn btn-primary mt-3" onClick={this.handleAddSections} >Add</Button>
                                    <Button className="btn btn-danger mt-3 ml-3" onClick={this.handleCancel} >cancel</Button>
                                </FormGroup>
                                <FormGroup>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>}
                />
            </Form>
        )
    }
}
const required = value => value ? undefined : 'Required';
ProductDetailsForm = reduxForm({
    form: 'productDetailsForm',
    enableReinitialize: true
})(ProductDetailsForm)

const mapStateToProps = (state, ownProps) => ({
    productFormData: state.form.productDetailsForm,
    productSectionList: state.corporateOnBoardingCreate.productSectionList,
    creditLimitModelList: state.corporateOnBoardingCreate.creditLimitModelList
});

const mapDispatchToProps = (dispatch, ownProps) => ({
});
export default ProductDetailsForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductDetailsForm)

const renderMembers = ({ fields, data ,dropDownOptions ,meta: { error, submitFailed } }) => {
    return(
    <ul>
       {(fields).map((member, index) => (
           <li key={index}>
           <Row>
               <Col >
                   <Row>
                       <Row>
                           <Col><span>{fields.get(index).label}</span></Col>
                           <Col md={5}><Field name={`${member}.weightage`}
                           type="number"
                           className="form-control mb-2 mr-sm-2 mb-sm-0"
                           component="input"  
                           required/></Col>
                           <Col md={6.1}>
                           <Field name={`${member}.typeOfBuyerSellerRelationship`} component="select" className="form-control dropdown-counterparty border">
                           <option value=''>Select</option>
                           {
                            dropDownOptions.map(p => {
                                return (
                                    <option key={p.id} value={p.id}>{p.id}</option>
                                )
                            })
                           }
                           </Field>
                           </Col>
                           <Col md={5}><Field name={`${member}.creditDays`}
                           type="number"
                           className="form-control mb-2 mr-sm-2 mb-sm-0"
                           component="input"  
                           />
                           </Col>
                           <Col>
                           <button type="button" onClick={() => fields.remove(index)}>&times;</button>
                           </Col>
                       </Row>    
                   </Row>
               </Col>
           </Row>
           <br/>
       </li>    
       ))}
   </ul>
)}